import { render, staticRenderFns } from "./HistoricoLlamadas.vue?vue&type=template&id=856a7e4a"
import script from "./HistoricoLlamadas.vue?vue&type=script&lang=js"
export * from "./HistoricoLlamadas.vue?vue&type=script&lang=js"
import style0 from "./HistoricoLlamadas.vue?vue&type=style&index=0&id=856a7e4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDataTable,VDialog,VIcon})
